package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Level
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.CompetenceState
import io.horion.cv.styles.CompetenceEqualFieldStyle
import io.horion.cv.styles.CompetenceFieldsRowStyle
import io.horion.cv.styles.CompetenceFormStyle
import io.horion.cv.styles.CompetenceLevelLabelStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.css.paddingRight
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text

val niveauMapping = mapOf(
    "Débutant" to Level.BEGINNER,
    "Intermédiaire" to Level.INTERMEDIATE,
    "Bien" to Level.GOOD,
    "Très bien" to Level.VERY_GOOD,
    "Excellent" to Level.EXCELLENT
)
val reverseNiveauMapping = niveauMapping.entries.associate { it.value to it.key }

@Composable
fun CompetenceForm(
    index: Int,
    state: CompetenceState,
    cvViewModel: CvViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {
    val updateVM = {
        val selectedLevel =
            niveauMapping[state.niveau] ?: Level.BEGINNER

        val updatedComp = io.horion.cv.api.datasource.cv.Competence(
            name = state.competence,
            level = selectedLevel
        )

        cvViewModel.updateCompetence(index, updatedComp)
    }

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val labelColor = if (isDark) Colors.White else Colors.Primary

    Column(
        modifier = CompetenceFormStyle.toModifier()
    ) {
        Row(
            modifier = CompetenceFieldsRowStyle.toModifier()
        ) {
            TextFormField(
                label = "Compétence",
                value = state.competence,
                onValueChange = {
                    state.competence = it
                    updateVM()
                },
                modifier = CompetenceEqualFieldStyle.toModifier()
            )

            Column(
                modifier = CompetenceEqualFieldStyle.toModifier(),
                horizontalAlignment = Alignment.Start
            ) {
                SpanText(
                    text = "Niveau",
                    modifier = CompetenceLevelLabelStyle
                        .toModifier()
                        .color(labelColor)
                )

                NiveauDropdown(
                    selectedNiveau = state.niveau,
                    onNiveauChange = {
                        state.niveau = it
                        updateVM()
                    },
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}

@Composable
fun NiveauDropdown(
    selectedNiveau: String,
    onNiveauChange: (String) -> Unit,
    modifier: Modifier = Modifier,
) {
    val niveaux = listOf(
        "Débutant",
        "Intermédiaire",
        "Bien",
        "Très bien",
        "Excellent"
    )
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Select(
        attrs = modifier
            .fillMaxWidth()
            .height(40.px)
            .toAttrs {
                style {
                    backgroundColor(
                        if (isDark) Colors.input else Colors.LightGray
                    )
                    color(
                        if (isDark) Colors.White else Colors.Black
                    )
                    border(0.px)
                    borderRadius(5.px)
                    paddingLeft(10.px)
                    paddingRight(20.px)
                    fontSize(16.px)
                    cursor("pointer")
                    property("transition", "border-color 200ms")
                    property("outline", "none")
                    property("box-sizing", "border-box")
                    property("min-width", "0")
                }

                onChange { event ->
                    onNiveauChange(event.target.value)
                }
            }
    ) {
        Option(
            value = "",
            attrs = {
                if (selectedNiveau.isEmpty()) selected()
                style {
                    color(Colors.Primary)
                }
            }
        ) {
            Text("Choisissez")
        }

        niveaux.forEach { niveau ->
            Option(
                value = niveau,
                attrs = {
                    if (niveau == selectedNiveau) {
                        selected()
                    }
                    style {
                        backgroundColor(Colors.input)
                        color(Colors.White)
                    }
                }
            ) {
                Text(niveau)
            }
        }
    }
}